import styled from '@emotion/styled';
import { theme } from '@pairy/styles';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

/*
 * V1과 동일한 배치: 배경 바 없이 슬라이드 영역(MainColumn) 위에
 * 좌상단/우상단/하단 중앙으로 흩어진 플로팅 컨트롤.
 * isDisableHelpers 시 반투명 처리(V1 파리티).
 */
const helperDim = `
  transition: opacity 0.15s ease-in-out;

  &.disabled {
    cursor: initial;
    opacity: 0.25;
  }
`;

export const TopRightWrapper = styled.div`
  position: absolute;
  z-index: ${VIEWER_Z_INDEX.desktopLayer};
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  padding: 32px 48px;
  gap: 8px;
  ${helperDim}
`;

/* V1 DesktopPageNavigationButton과 동일한 반투명 블러 필 */
export const BottomNavWrapper = styled.div`
  position: absolute;
  z-index: ${VIEWER_Z_INDEX.desktopLayer};
  bottom: 32px;
  left: 50%;
  display: flex;
  align-items: center;
  border: 1px solid ${theme.colors.zinc_500};
  backdrop-filter: blur(8px);
  background: rgb(255 255 255 / 50%);
  border-radius: 9999px;
  transform: translateX(-50%);
  ${helperDim}
`;

/* V1 DesktopPageMoveButton과 동일한 투명 화살표 버튼 */
export const NavArrowButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: opacity 0.15s ease-in-out;

  &:disabled {
    cursor: initial;
    opacity: 0.25;
  }
`;
